<ng-template #permissionReadonly>
  This permission is assigned to the tenant and cannot be modified here.
</ng-template>
@if (filterMatches) {
  @if (dataSource) {
    <mat-table [dataSource]="dataSource" class="adm4-mat-table no-shadow">
      <ng-container [matColumnDef]="nameColumn">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="name-container">
            @if (isGroup(element)) {
              <mat-icon>group</mat-icon>
            } @else {
              <mat-icon>perm_identity</mat-icon>
            }
            <span class="ms-2">{{element | permissionAssigneeName}}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container [matColumnDef]="usernameColumn">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Username</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element | permissionAssigneeUsername}}
        </mat-cell>
      </ng-container>
      @for (operationColumn of operationColumns; track operationColumn) {
        <ng-container [matColumnDef]='operationColumn.columnKey'>
          <mat-header-cell mat-header-cell *matHeaderCellDef>{{operationColumn.columnLabel}}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [ngbTooltip]='permissionReadonly' placement='bottom' [disableTooltip]="!isDisabled(element, operationColumn.operationKey)">
              @if (editMode) {
                <mat-checkbox
                  (change)="onSelectionChange($event, element, operationColumn.operationKey)"
                  [checked]="hasPermissionToOperation(element, operationColumn.operationKey)"
                  [disabled]="isDisabled(element, operationColumn.operationKey)">
                </mat-checkbox>
              } @else {
                @if (hasPermissionToOperation(element, operationColumn.operationKey)) {
                  <mat-icon>done</mat-icon>
                }
              }
            </span>
          </mat-cell>
        </ng-container>
      }
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  }
} @else {
  <div class="no-filter-results">{{NO_PERMISSION_FOUND}}</div>
}
